import { EventEmitter, Injectable } from '@angular/core';
import { Observable, Subject, tap } from 'rxjs';
import { ApiCallService } from './api-call-service.service';
import { LoaderService } from './loader-service.service';
// export interface Game {
//   id: number;
//   name: string;
//   image: string;
//   offer: number;
//   buttonText: string;
//   downloadLink: string;
//   provider: string;
//   hot: string;
// }
@Injectable({
  providedIn: 'root',
})
export class GameService {
  private gameData: any;
  getGames(): any[] {
    return this.games;
  }

  getGameById(id: number): any | undefined {
    return this.games.find((game) => game.id === id);
  }
  games: any[] = [
    {
      id: 1,
      name: 'EGame',
      image: 'https://cmax-2.pages.dev/assets/game/Egame.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/Egame.jpeg',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'https://www.egame99.club/',
      provider: 'Dragon Gaming',
      isHot: false,
      bgclr: "#FF9E00",
      color2: "#E01E5A",
      color3: "#3F0E40",
      description: 'Dive into a classic collection of highly immersive arcade mechanics and slot simulation games. Engineered with top-tier physics engines, it delivers smooth reel transitions and rewarding bonus rounds perfect for both casual enthusiasts and high rollers looking for long play sessions.'
    },
    {
      id: 2,
      name: 'GameVault',
      image: 'https://cmax-2.pages.dev/assets/game/GameVault-game.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/GameVault-game-old.png',
      provider: 'Game Vault',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'https://download.gamevault999.com/',
      isHot: false,
      bgclr: "#E91E63",
      color2: "#29B6F6",
      color3: "#0288D1",
      description: 'Unlock a secure digital vault featuring a premium, curated selection of high-stakes slot thrills and sweepstakes layouts. Experience real-time multiplayer updates, enhanced cybersecurity for profile tracking, and ultra-crisp audio tracking that heightens the tension with every spin.'
    },
    {
      id: 3,
      name: 'GoldenTreasure',
      image: 'https://cmax-2.pages.dev/assets/game/GoldenTreasure-game.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/GoldenTreasure-game-old.png',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'https://www.goldentreasure.mobi/',
      provider: 'Golden',
      isHot: false,
      bgclr: "#EC407A",
      color2: "#AB47BC",
      color3: "#26C6DA",
      description: 'Embark on an epic ancient quest to uncover lost fortunes, legendary artifacts, and hidden golden multipliers buried deep within mysterious chambers. Features an intricate progressive jackpot tier system that rewards patience and tactical line adjustments.'
    },
    {
      id: 4,
      name: 'Juwa',
      image: 'https://cmax-2.pages.dev/assets/game/Juwa-game.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/Juwa-game-old.png',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'https://dl.juwa777.com/',
      provider: 'Juwa',
      isHot: false,
      bgclr: "#9C27B0",
      color2: "#2196F3",
      color3: "#00E5FF",
      description: 'Experience a fast-paced, action-packed social fish hunting sweepstakes arena that challenges your reflexes and strategy. Lock onto multi-point deep-sea creatures, customize your cannon power modifiers, and compete with active global players in real-time lobbies.'
    },
    {
      id: 5,
      name: 'UltraPanda',
      image: 'https://cmax-2.pages.dev/assets/game/UltraPanda-game.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/UltraPanda-game-old.png',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'https://www.ultrapanda.mobi/',
      provider: 'Master Gaming',
      isHot: false,
      bgclr: "#00E676",
      color2: "#6A1B9A",
      color3: "#311B92",
      description: 'Join forces with the ultimate panda guardian in an environment designed for ultra-rewarding reels and community jackpot drops. Packed with expanding sticky wilds, multi-lane combo bonuses, and an aesthetic that blends eastern mythology with arcade style.'
    },
    {
      id: 6,
      name: 'VBLink',
      image: 'https://cmax-2.pages.dev/assets/game/Vblink.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/VbLink-old2.jpg',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'https://www.vblink777.club/',
      provider: 'Master Gaming',
      isHot: false,
      bgclr: '#FF1744',
      color2: '#880E4F',
      color3: '#0A0010',
      description: 'Connect instantly to high-octane multiplayer card rooms and classic casino tables optimized for low latency. This seamless hub blends standard sweepstakes mechanics with high-fidelity streaming elements, ensuring you never miss a beat during quick betting intervals.'
    },
    {
      id: 7,
      name: 'Vegas',
      image: 'https://cmax-2.pages.dev/assets/game/Sweeps.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/Sweeps-old2.jpeg',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'http://m.lasvegassweeps.com/',
      provider: 'Master Gaming',
      isHot: false,
      bgclr: "#00E5FF",
      color2: "#76FF03",
      color3: "#FFEA00",
      description: 'Bring the dazzling neon lights, roaring crowd sounds, and high-roller adrenaline of the classic Las Vegas strip straight to your screen. Features multi-game quick switching, optimized scaling for mobile formats, and generous introductory reward systems.'
    },
    {
      id: 8,
      name: 'GameRoom',
      image: 'https://cmax-2.pages.dev/assets/game/GamerRoom-game.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/GamerRoom-game-old.png',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'https://www.gameroom777.com/',
      provider: 'Game Vault',
      isHot: false,
      bgclr: '#1A237E',
      color2: '#0D47A1',
      color3: '#10121A',
      description: 'Your premium digital hub for multi-choice arcade classics, fish target ranges, and physics-based skill challenges. GameRoom offers localized leaderboards, customizable UI skins, and highly responsive pointer controls tailored for perfect targeting accuracy.'
    },
    {
      id: 9,
      name: 'MilkyWay',
      image: 'https://cmax-2.pages.dev/assets/game/MilkyWays.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/MilkyWays-old2.jpg',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'https://milkywayapp.xyz/',
      provider: 'Milky',
      isHot: false,
      bgclr: '#263238',
      color2: '#004D40',
      color3: '#006064',
      description: 'Blast off on a cosmic journey across an expansive galaxy of deep-space rewards, shifting nebulas, and unconventional reel structures. Includes zero-gravity multiplier cascades and daily cosmic debris drops that grant sudden mystery spins to users.'
    },
    {
      id: 10,
      name: 'FireKirin',
      image: 'https://cmax-2.pages.dev/assets/game/Fire.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/Fire-old2.webp',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'http://start.firekirin.xyz:8580/',
      provider: 'Fire Kirin',
      isHot: false,
      bgclr: '#00E676',
      color2: '#FF6D00',
      color3: '#3E2723',
      description: 'Unleash absolute explosive firepower in the undisputed gold standard of online fish hunting games. Track the legendary Kirin dragon, load high-yield laser nets, and enjoy optimized particle animations that turn every successful capture into an arcade spectacle.'
    },
    {
      id: 11,
      name: 'OrionStar',
      image: 'https://cmax-2.pages.dev/assets/game/OrionStars.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/OrionStars-old2.jpg',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'http://start.orionstars.vip:8580/',
      provider: 'Orion',
      isHot: false,
      bgclr: '#00E676',
      color2: '#212121',
      color3: '#0A0A0A',
      description: 'A stellar network of sweepstakes platforms featuring highly advanced multi-line mechanics, rapid bonus re-triggers, and sleek modern rendering. OrionStar specializes in keeping the action continuous with minimal loading breaks between major prize drops.'
    },
    {
      id: 12,
      name: 'Yolo',
      image: 'https://cmax-2.pages.dev/assets/game/yolo.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/yolo-old.jpeg',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'https://yolo777.game/',
      provider: 'Master Gaming',
      isHot: false,
      bgclr: '#00E5FF',
      color2: '#2979FF',
      color3: '#1A237E',
      description: 'Take bold risks, play outside your comfort zone, and embrace the thrill in a neon lounge built specifically for high-energy sessions. It features double-or-nothing modifiers, surprise sudden-death tournaments, and an interactive chat wheel functionality.'
    },
    {
      id: 13,
      name: 'CashMachine',
      image: 'https://cmax-2.pages.dev/assets/game/cash-machine-jackpots.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/cash-machine-jackpots-old.jpg',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'https://www.cashmachine777.com/m',
      provider: 'Master Gaming',
      isHot: false,
      bgclr: '#607D8B',
      color2: '#37474F',
      color3: '#1A237E',
      description: 'Pull the vintage mechanical levers on a distinct mathematical matching system that translates directly into cash payouts. No complicated plots—just raw numbers, direct alignments, and clear red-hot jackpot milestones that update instantly across the system.'
    },
    {
      id: 14,
      name: 'BlueDragon',
      image: 'https://cmax-2.pages.dev/assets/game/blue-dragon.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/blue-dragon-old.jpeg',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'http://app.bluedragon777.com/',
      provider: 'Master Gaming',
      isHot: false,
      bgclr: '#0288D1',
      color2: '#26C6DA',
      color3: '#004D40',
      description: 'Conquer the deep waters and tame the mythical blue dragon in an ecosystem rich with underwater caverns, massive treasure boxes, and legendary boss fights. Harness special freeze power-ups to stall high-value targets before they escape the board.'
    },
    {
      id: 16,
      name: 'CashVault',
      image: 'https://cmax-2.pages.dev/assets/game/cash-vault.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/cash-vault-old.jpeg',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'cashvault777.com',
      provider: 'Master Gaming',
      isHot: false,
      bgclr: "#E91E63",
      color2: "#29B6F6",
      color3: "#0288D1",
      description: 'Crack complex safe combinations and decipher high-security numeric matrices to unlock progressive multiplier rooms. CashVault blends classic safe-cracker logic with quick-win sweepstakes loops designed for maximum feedback loops.'
    },
    {
      id: 17,
      name: 'MrAll',
      image: 'https://cmax-2.pages.dev/assets/game/mr-all.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/mr-all-old.jpeg',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'http://www.mrallinone777.com',
      provider: 'Master Gaming',
      isHot: false,
      bgclr: '#1A237E',
      color2: '#90CAF9',
      color3: '#121620',
      description: 'An expansive all-in-one suite packing your absolute favorite slots, lottery-style keno grids, and specialty pull-tab scratchers under a singular dashboard. Ideal for players who enjoy switching playstyles on the fly without changing platforms.'
    },
    {
      id: 18,
      name: 'CashFrenzy',
      image: 'https://cmax-2.pages.dev/assets/game/cash-frenzy.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/cash-frenzy-old.png',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'http://www.cashfrenzy777.com/',
      provider: 'Master Gaming',
      isHot: false,
      bgclr: '#4DB6AC',
      color2: '#00ACC1',
      color3: '#006064',
      description: 'Ride an unstoppable wave of rapid free-spin cycles, hourly token distribution systems, and global community achievement milestones. This high-volatility setting keeps your engagement peaked with bright animations and constant mini-game alerts.'
    },
    {
      id: 19,
      name: 'Mafia',
      image: 'https://cmax-2.pages.dev/assets/game/mafia.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/mafia-old.jpg',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'http://www.mafia77777.com',
      provider: 'Master Gaming',
      isHot: false,
      bgclr: '#AA00FF',
      color2: '#FF6D00',
      color3: '#FF3D00',
      description: 'Climb the dangerous underground ranks in a gritty, high-stakes underworld turf battle format. Establish your cartel domain by unlocking customized high-yield slots themed around iconic mob heists, bank vaults, and high-speed getaway runs.'
    },
    {
      id: 20,
      name: 'VegasLuck',
      image: 'https://cmax-2.pages.dev/assets/game/vegas-luck.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/vegas-luck-old.jpeg',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'https://start.vegasluck777.com',
      provider: 'Master Gaming',
      isHot: false,
      bgclr: '#00dbde',
      color2: '#99f2c8',
      color3: '#00c853',
      description: 'Test your raw fortunes within a neon-soaked, wheel-based layout precision-tuned for massive clover and horseshoe multiplier triggers. Offers a streamlined interface that executes smoothly even on limited hardware constraints.'
    },
    {
      id: 22,
      name: 'WinStar',
      image: 'https://cmax-2.pages.dev/assets/game/win-star.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/win-star-old.jpeg',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'http://www.winstar99999.com',
      provider: 'Master Gaming',
      isHot: false,
      bgclr: '#00dbde',
      color2: '#f9d423',
      color3: '#00c853',
      description: 'Align bright star constellations and celestial objects across dynamic paylines to kick off stunning widescreen cinematic bonuses. Watch out for randomly occurring solar flares that transform base icons into wild sticky multipliers.'
    },
    {
      id: 23,
      name: 'AceClub',
      image: 'https://cmax-2.pages.dev/assets/game/ace-club.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/ace-club-old.jpeg',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'https://www.ace777.club',
      provider: 'Master Gaming',
      isHot: false,
      bgclr: '#00dbde',
      color2: '#D9ECC7',
      color3: '#00c853',
      description: 'An elite virtual lounge crafted meticulously for gaming purists seeking high-limit blackjack models, single-deck configurations, and premium poker rooms. Features clean table layouts that omit clutter for zero distractions.'
    },
    {
      id: 24,
      name: 'LuckyStar',
      image: 'https://cmax-2.pages.dev/assets/game/lucky-star.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/lucky-star-old.jpeg',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'https://www.luckystars.games/',
      provider: 'Master Gaming',
      isHot: false,
      bgclr: '#00dbde',
      color2: '#00ffe0',
      color3: '#00c853',
      description: 'Map out your winning coordinates by aligning celestial icons. LuckyStar introduces unique multi-directional cluster payouts where matching symbols vertically, horizontally, or diagonally sparks sudden chain reactions.'
    },
    {
      id: 10014,
      name: 'Juwa2',
      image: 'https://cmax-2.pages.dev/assets/game/juwa2.png',
      coverImage: 'https://cmax-2.pages.dev/assets/game/Juwa-game-old.png',
      offer: 0,
      buttonText: 'Add Player',
      downloadLink: 'https://m.juwa2.com/',
      provider: 'Juwa',
      isHot: false,
      bgclr: '#C51162',
      color2: '#7B1FA2',
      color3: '#00E5FF',
      description: 'The highly anticipated, powerhouse sequel updating classic fish targeting structures with ultra-crisp high-definition assets, intelligent creature behavior AI, and massive multi-stage kraken and leviathan global boss events.'
    }
  ];
  constructor(
    private apiCallService: ApiCallService,
    private loaderService: LoaderService
  ) { }
  showChat: boolean = false;
  // Setter function
  setGameData(data: any): void {
    this.gameData = data;
  }
  get SystemGames() {
    return this.systemGames;
  } private systemGames: any[] = [
    {
      id: 25,
      name: 'Aviator',
      image: '/Images/Avaitar.png',
      coverImage: '/Images/Avaitar.png',
      offer: 0,
      buttonText: 'Play Now',
      downloadLink: '/dashboard/Avaitar',
      provider: 'Master Gaming',
      isHot: true,
      bgclr: '#FF0055', // Vibrant Crimson
      color2: '#7A00FF', // Deep Purple
      color3: '#00E5FF'  // Electric Cyan
    },
    {
      id: 26,
      name: 'Bacchrat',
      image: '/Images/Baccarat.png',
      coverImage: '/Images/Baccarat.png',
      offer: 0,
      buttonText: 'Play Now',
      downloadLink: '/dashboard/Baccaret',
      provider: 'Master Gaming',
      isHot: true,
      bgclr: '#00FF87', // Neon Green
      color2: '#60EFFF', // Ice Blue
      color3: '#0061FF'  // Electric Blue
    },
    {
      id: 27,
      name: 'Treasure',
      image: '/Images/treasure-vault.png',
      coverImage: '/Images/treasure-vault.png',
      offer: 0,
      buttonText: 'Play Now',
      downloadLink: '/dashboard/TreasurePick',
      provider: 'Master Gaming',
      isHot: true,
      bgclr: '#FF9900', // Bright Orange
      color2: '#FF007A', // Hot Pink
      color3: '#310062'  // Dark Violet
    },
    {
      id: 28,
      name: 'Mines',
      image: '/bomb.png',
      coverImage: '/bomb.png',
      offer: 0,
      buttonText: 'Play Now',
      downloadLink: '/dashboard/Mines',
      provider: 'Master Gaming',
      isHot: true,
      bgclr: '#FFE600', // Laser Yellow
      color2: '#FF005C', // Vivid Magenta
      color3: '#5200FF'  // Intense Blue-Purple
    },
    {
      id: 29,
      name: 'Plinko',
      image: '/plinko.png',
      coverImage: '/plinko.png',
      offer: 0,
      buttonText: 'Play Now',
      downloadLink: '/dashboard/Plinko',
      provider: 'Master Gaming',
      isHot: true,
      bgclr: '#00FFFF', // Bright Cyan
      color2: '#FF00FF', // Pure Magenta
      color3: '#2600FF'  // Deep Ultramarine
    },
    {
      id: 30,
      name: 'Roulette',
      image: '/Rouleet.png',
      coverImage: '/Rouleet.png',
      offer: 0,
      buttonText: 'Play Now',
      downloadLink: '/dashboard/Roulette',
      provider: 'Master Gaming',
      isHot: true,
      bgclr: '#FF3300', // Flame Red
      color2: '#B700FF', // Bright Violet
      color3: '#000839'  // Midnight Blue
    },
    {
      id: 32,
      name: 'Kino',
      image: '/Images/keno.png',
      coverImage: '/Images/keno.png',
      offer: 0,
      buttonText: 'Play Now',
      downloadLink: '/dashboard/Keno',
      provider: 'Master Gaming',
      isHot: true,
      bgclr: '#9DFF00', // Lime Green
      color2: '#00EFFF', // Cyan Glow
      color3: '#001A4E'  // Deep Sea Navy
    },
    {
      id: 33,
      name: 'Scratch',
      image: '/Images/sactrach.png',
      coverImage: '/Images/sactrach.png',
      offer: 0,
      buttonText: 'Play Now',
      downloadLink: '/dashboard/SectrechCards',
      provider: 'Master Gaming',
      isHot: true,
      bgclr: '#FF00C4', // Neon Pink
      color2: '#FF9900', // Neon Orange
      color3: '#4A00E0'  // Rich Royal Purple
    },
    {
      id: 34,
      name: 'Spinner',
      image: '/Images/spin.png',
      coverImage: '/Images/spin.png',
      offer: 0,
      buttonText: 'Play Now',
      downloadLink: '/dashboard/spinner',
      provider: 'Master Gaming',
      isHot: true,
      bgclr: '#00FFCC', // Mint Aqua
      color2: '#3A1175', // Dark Velvet Purple
      color3: '#10002B'  // Near Black
    },
  ];
  // Getter function
  getGameData(): any {
    return this.gameData;
  }
  //   Funtion call service use
  private triggerSubject = new EventEmitter<void>();

  triggerFunction() {
    // Check if the function is already in the process of being triggered
    this.triggerSubject.emit();
  }

  getTriggerObservable() {
    return this.triggerSubject.asObservable();
  }
  //   Funtion call service use
  private triggerChatSubject = new EventEmitter<void>();

  triggerShowChatFunction() {
    // Check if the function is already in the process of being triggered
    this.triggerChatSubject.emit();
  }

  getTriggerShowChatObservable() {
    return this.triggerChatSubject.asObservable();
  }
  getCustomerID(): number {
    return Number(localStorage.getItem('customerId')?.length);
  }
  setArrayInLocalStorage(data: any[]) {
    localStorage.setItem('bis_data', JSON.stringify(data));
  }
  getArrayInLocalStorage(locale: string): any[] {
    return JSON.parse(localStorage.getItem(locale) || '[]');
  }

  //   Funtion call service use Game Updates
  private triggerGetHotHittingGames = new EventEmitter<void>();

  triggerHotHittingGames() {
    this.triggerGetHotHittingGames.emit();
  }

  getTriggerHotHittingGamesObservable() {
    return this.triggerGetHotHittingGames.asObservable();
  }
  //   Funtion call service use Game Updates
  private triggerGetUpdatedGames = new EventEmitter<void>();

  triggerUpdatedGames() {
    this.triggerGetUpdatedGames.emit();
  }

  getTriggerUpdatedGamesObservable() {
    return this.triggerGetUpdatedGames.asObservable();
  }
  getHotHittingGames(): void {
    this.apiCallService
      .GetCallWithToken('TestImonials/GetHotHittingGames')
      .subscribe({
        next: (response: any) => {
          if (response?.responseCode === 200) {
            this.loaderService.setArrayInLocalStorage(
              'bis_offer',
              response.data ?? []
            );

            this.triggerUpdatedGames(); // runtime update
          }
        },
        error: (error) => {
          console.error('Failed to load hot hitting games', error);
        },
      });
  }

  /////////////////////geter setter for balance

  private _balance!: number;

  // Getter to retrieve the balance
  get balance(): number {
    return this._balance;
  }

  // Setter to update the balance
  set balance(value: number) {
    this._balance = value;
  }

  // Function to handle wallet values Start
  // private actionSource = new Subject<void>(); // Can pass data if needed
  // action$ = this.actionSource.asObservable();

  // triggerAction() {
  //   this.actionSource.next(); // Notify subscribers
  // }
  // Function to handle wallet values End

  saveTotalBalance(totalBalance: number) {
    localStorage.setItem('totalBalance', totalBalance.toString());
  }

  getTotalBalance(): number {
    const totalBalance = localStorage.getItem('totalBalance');
    return totalBalance ? parseFloat(totalBalance) : 0;
  }
}
